(()=>{
  if(window.__vivaAskExactResponseGuard)return;
  window.__vivaAskExactResponseGuard=true;
  const params=new URLSearchParams(location.search);
  const requestedHandle=String(params.get('product')||'').trim().toLowerCase();
  const requestedVariant=String(params.get('variant')||'').replace(/\D/g,'');
  const requestedProduct=String(params.get('product_id')||'').replace(/\D/g,'');
  const exactTransport=!!requestedHandle&&!!(requestedVariant||requestedProduct);
  if(!exactTransport)return;
  const nativeFetch=window.fetch.bind(window);
  const isAsk=url=>/\/api\/ask-viva(?:\?|$)/.test(String(url||''));
  const numeric=v=>String(v||'').split('/').pop()?.replace(/\D/g,'')||'';
  const canonicalVerifiedAsset=visual=>String(visual?.verified_data_url||visual?.verified_image_url||'').trim();
  window.fetch=async(input,init)=>{
    const url=typeof input==='string'?input:input?.url||'';
    const response=await nativeFetch(input,init);
    if(!isAsk(url))return response;
    try{
      const data=await response.clone().json();
      if(!data?.ok)return response;
      const mode=data?.stages?.analyze?.experience_mode||'';
      const p=data?.stages?.analyze?.context_product||{};
      const visual=data?.stages?.visualize||{};
      const verify=data?.stages?.verify||{};
      const handleOk=String(p.handle||'').toLowerCase()===requestedHandle;
      const productOk=!requestedProduct||numeric(p.product_id||p.product_numeric_id)===requestedProduct;
      const variantOk=!requestedVariant||numeric(p.variant_numeric_id||p.variant_id)===requestedVariant;
      const lockOk=p.variant_lock_ok===true;
      let error='',diagnostic='';
      if(mode!=='product_led'||!handleOk||!productOk||!variantOk||!lockOk){
        error='REFERENCE_MISMATCH';diagnostic='PDP_EXACT_CONTEXT_GUARD';
      }else if(visual.status==='ready'&&visual.verified===true&&verify.status==='pass'){
        const score=Number(verify.score||0);
        if(verify.exact_product_match!==true){error='REFERENCE_MISMATCH';diagnostic='PDP_EXACT_PRODUCT_GUARD';}
        else if(score<90){error='VERIFICATION_FAILED';diagnostic='PDP_VISUAL_QA_SCORE_BELOW_90';}
        else if(!canonicalVerifiedAsset(visual)){error='VERIFIED_IMAGE_MISSING';diagnostic='PDP_CANONICAL_VERIFIED_ASSET_MISSING';}
      }
      if(error){
        data.ok=false;
        data.error=error;
        data.diagnostic_code=diagnostic;
        data.guardrail_failure={mode,handle_ok:handleOk,product_ok:productOk,variant_ok:variantOk,variant_lock_ok:lockOk,exact_product_match:verify.exact_product_match,verify_score:Number(verify.score||0),canonical_verified_asset:!!canonicalVerifiedAsset(visual)};
        const headers=new Headers(response.headers);headers.set('Content-Type','application/json');
        return new Response(JSON.stringify(data),{status:response.status,statusText:response.statusText,headers});
      }
    }catch(_){}
    return response;
  };
})();
